import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { useQuery, registerQuery } from 'data-fetching-client';
import { ContentObjectTypes } from 'content-management-data-lib';
import usePageContentObjectType from './usePageContentObjectType';
const StylesheetsQuery = registerQuery({
  fieldName: 'stylesheets',
  fetcher: ({
    id,
    pageType
  }) => {
    return http.get(`cospages/v2/${pageType}/${id}/stylesheet-trace`);
  }
});
const useFetchStylesheets = contentId => {
  const contentObjectType = usePageContentObjectType();
  const {
    data,
    loading,
    error
  } = useQuery(StylesheetsQuery, {
    variables: {
      id: contentId,
      pageType: contentObjectType === ContentObjectTypes.SITE_PAGE ? 'site-pages' : 'landing-pages'
    }
  });
  return useMemo(() => ({
    stylesheets: data === null || data === void 0 ? void 0 : data.stylesheets,
    stylesheetsLoading: loading,
    stylesheetsError: error
  }), [data, loading, error]);
};
export default useFetchStylesheets;